import React from 'react';
import { Card } from './ui/card';
import { Clock, MapPin } from 'lucide-react';

const Schedule = ({ data }) => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            Daily Schedule
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            A typical day at the High Performance Camp
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Schedule Timeline */}
          <Card className="p-8 bg-gradient-to-br from-gray-50 to-white">
            <div className="space-y-4">
              {data.dailySchedule.map((item, index) => (
                <div 
                  key={index} 
                  className="flex items-start pb-4 border-b border-gray-200 last:border-0 last:pb-0"
                >
                  <div className="flex-shrink-0 w-20">
                    <div className="flex items-center">
                      <Clock className="h-4 w-4 text-green-600 mr-2" />
                      <span className="text-sm font-bold text-gray-900">{item.time}</span>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-gray-700">{item.activity}</p>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          {/* Excursion Info */}
          <div className="space-y-8">
            <Card className="p-8 bg-gradient-to-br from-green-600 to-green-700 text-white">
              <MapPin className="h-10 w-10 mb-4" />
              <h3 className="text-2xl font-black mb-4">Special Excursions</h3>
              <p className="text-green-100 mb-6">
                {data.excursions}
              </p>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                <p className="text-sm font-semibold">
                  Experience England's iconic football culture firsthand with visits to legendary stadiums!
                </p>
              </div>
            </Card>

            {/* Additional Info */}
            <Card className="p-8 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
              <h3 className="text-xl font-black mb-4">Weekly Activities</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>4.5 hours of English lessons daily (Monday-Friday)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>2 training sessions per day in English</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>Trial matches with local teams</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>Video analysis and psychology workshops</span>
                </li>
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schedule;